import api from './api';
import types from './mutation-types';

export default {
	setSearchParam_({ commit }, { key, value }) {
		commit(types.SEARCH_PARAM, { key, value });
	},
	setState_({ commit }, { key, value }) {
		commit(types.DEFAULT_ASSIGN, { key, value });
	},
	setStateInit_({ commit }) {
		commit(types.STATE_INIT);
	},
	setPagingInfo_({ commit }, { key, value }) {
		commit(types.GROUPS, { key, value });
	},
	getMdjMList_({ commit, state }){
		const { searchParams, groups } = state;
		const param = {};
		param.partType = searchParams.partType;
		param.searchDate = searchParams.searchDate;
		param.currentPage = groups.currentPage;
		param.pageUnit = groups.pageUnit;
		return api
			.getMdjMList({ searchParams: param })
			.then(data => {
				if (data.header.code === 0) {
					const { resultList, pagingInfo,  typeStatisticList, itemStatisticList} = data.body;
					commit(types.DEFAULT_ASSIGN, { key: 'groups', value: pagingInfo });
					commit(types.DEFAULT_ASSIGN, { key: 'mdjTbList', value: resultList });
					commit(types.DEFAULT_ASSIGN, { key: 'ngCdList', value: typeStatisticList });
					commit(types.DEFAULT_ASSIGN, { key: 'ngCauseList', value: itemStatisticList });
					commit(types.DEFAULT_ASSIGN, {
						key: 'isLoading',
						value: true
					});
				}
				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	getMdjMStastic_({ commit, state }) {
		const { searchParams, ngType, ngItem } = state;
		return api
			.getMdjMStastic({ searchParams: searchParams })
			.then(data => {
				if (data.header.code === 0) {
					let typeStatisticList = data.body.typeStatisticList;
					let pieData =  [];
					for(let i = 0; i < ngType.length; i++){
						let typeCd = ngType[i].commCd;
						let ngNum = 0;
						for(let j = 0; j < typeStatisticList.length; j++){
							let typeStatistic = typeStatisticList[j];
							if(typeStatistic.cd == typeCd){
								ngNum = typeStatistic.ngNum
								break;
							}
						}
						pieData.push(ngNum);
					}
					commit(types.DEFAULT_ASSIGN, {
						key: 'pieChartData',
						value: pieData
					});

					let itemStatisticList = data.body.itemStatisticList;
					let partType = searchParams.partType;
					let itemList = ngItem.get(partType);
					let barData = [];
					let maxNgBarData = 0;
					for(let k = 0; k < itemList.length; k++){
						let itemCd = itemList[k].commCd;
						let ngNum = 0;
						for(let z = 0; z < itemStatisticList.length; z++){
							let itemStatistic = itemStatisticList[z];
							if(itemStatistic.cd == itemCd){
								ngNum = itemStatistic.ngNum
								break;
							}
						}
						barData.push(ngNum);
						maxNgBarData = maxNgBarData > ngNum ? maxNgBarData : ngNum;
					}
					
					commit(types.DEFAULT_ASSIGN, {
						key: 'maxbarVal',
						value: maxNgBarData + 20
					});

					commit(types.DEFAULT_ASSIGN, {
						key: 'barChartData',
						value: barData
					});

					commit(types.DEFAULT_ASSIGN, {
						key: 'isLoading',
						value: true
					});
					let resultList = data.body.resultList;
					let tbDataList = [];
					if(resultList && resultList.length > 0){
						for(let index = 0; index < resultList.length; index++){
							let currTbData = resultList[index];
							for(let i = 0; i < ngType.length; i++){
								let currNgType = ngType[i];
								if(currNgType.commCd == currTbData.qmsDefectCd){
									currTbData[currNgType.commCd] = "1";
								}else{
									currTbData[currNgType.commCd] = "";
								}
							}
							for(let k = 0; k < itemList.length; k++){
								let itemCd = itemList[k].commCd;
								if(currTbData.qmsDefectCause == itemCd){
									currTbData[itemCd] = "1";
								}else{
									currTbData[itemCd] = "";
								}
							}
							tbDataList.push(currTbData);
						}
					}
					commit(types.DEFAULT_ASSIGN, { key: 'mdjTbList', value: tbDataList });
					commit(types.DEFAULT_ASSIGN, { key: 'ngCdList', value: typeStatisticList });
					commit(types.DEFAULT_ASSIGN, { key: 'ngCauseList', value: itemStatisticList });
				}
				return data.header;
			})
			.catch(error => {
				throw error.header ? error.header : error;
			});
	},
	postSearchColList_({ commit, state }) {
		const { searchParams } = state;
		const that = this;
		return api
			.postSearchColList()
			.then(data => {
				if (data.header.code === 0) {
					const defectTypeList = data.body.defectTypeList;
					commit(types.DEFAULT_ASSIGN, {
						key: 'ngType',
						value: defectTypeList
					});

					let pieChartLabel = [];
					for(let i = 0; i < defectTypeList.length; i++){
						pieChartLabel.push(defectTypeList[i].commCdName);
					}
					commit(types.DEFAULT_ASSIGN, {
						key: 'pieChartLabel',
						value: pieChartLabel
					});
					const defectMeaList = data.body.defectMeaList;
					const defectEgaList = data.body.defectEgaList;
					const itemList = new Map();
					itemList.set('MEA', defectMeaList);
					itemList.set('EGA', defectEgaList);
					commit(types.DEFAULT_ASSIGN, {
						key: 'ngItem',
						value: itemList
					});
			}
			return data.header;
		})
		.catch(error => {
			throw error.header ? error.header : error;
		});
	}
};
